<template>
    <div>
        <div>
            <b-nav tabs>
                <template v-if="canViewSuperAdmin">
                    <b-nav-item router-link to="products-stock">
                        <icon name="file"></icon>
                        ประวัติการนำเข้า/ออกไฟล์
                    </b-nav-item>&nbsp;
                </template>
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
import {
    canViewSuperAdmin
} from "../../util/Permissions"

export default {
    name: "products-stock",
    computed: {
        canViewSuperAdmin
    }
}
</script>

<style scoped></style>
